export default device => {
    return device.extra['ip'] || device.extra['mbus_id'] || device.extra['modbus_id'] || device.extra['one_wire_id'] || null;
};
